// A idéia aqui é ter um enum padronizado com os "códigos de produto" para que ao registrar um evento, possamos utilizar
// esse mesmo código para entender mais da "origem" do evento. Por exemplo: "Portfolio" (Minha Carteira) ou "Screener" (Screener)

export enum FundamentalProductOriginCodes {
  SCREENER = "Screener",
}
